import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BackButtonPage } from "components/__new/common/BackButton";
import { ButtonLoader } from "components/__new/common/form";
import { useHistory } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { toast } from "react-toastify";
import Maybe from "components/__new/common/Maybe";
import iconDownload from "assets/images/icons/project-icons/download.svg";
import bulkAirtimeDownload from "assets/images/icons/project-icons/bulk-airtime-download.svg";
import iconDocCsv from "assets/images/icons/icon-doc-csv.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useLoginInfo from "hooks/useLoginInfo";
import maskEmailAddress from "utils/maskData";
import { FileUploader } from "react-drag-drop-files";
import getFileSize from "utils/getFileSize";
import FileUploadUI from "components/__new/common/form/FileUploadUI";
import * as walletAction from "store/entities/wallet/action";
import FormDrawer from "components/__new/common/form-drawer";
import Spinner from "components/__new/common/Spinner";
import successGif from "assets/images/icons/success-green.gif";
import { CSVLink } from "react-csv";
import PinInput from 'react-pin-input';
import ResetAccessPin from "components/__new/common/access-pin/ResetAccessPin";
import PageContent from "components/__new/common/PageContent";



export const BulkBeneficiaries = () => {
    const csvRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const {userInfo, logoutUser} = useLoginInfo();
    const { bulkBeneficiaryCreateData, bulkBeneficiaryCreateLoading, bulkBeneficiaryOtpLoading, bulkBeneficiaryOtpCount } = useSelector((s) => s.entities.wallet);    
    
    const [bulkUpload, setBulkUpload] = useState(null);
    const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [otp, setOtp] = useState("");
    const [failedUploads, setFailedUploads] = useState([]);
    const [resendShown, setResendShown] = useState(false);

    
    const columns = [
		{ label: "Beneficiary Name", key: "record" },
		{ label: "Error", key: "error" },
	]


    const onProceed = () => { 
        dispatch(walletAction.generateBulkBeneficiaryOtp(userInfo.token, "beneficiary")).then(() => {
            setIsOtpModalOpen(true);
        })
    }
    
    
    useEffect(() => {
        if (bulkBeneficiaryCreateData?.success === true && isOtpModalOpen){
            setIsOtpModalOpen(false);
            setIsSuccessModalOpen(true);
            setFailedUploads(bulkBeneficiaryCreateData?.data?.failedRecords);
        }
        // eslint-disable-next-line
    }, [bulkBeneficiaryCreateData])
    
    
    useEffect(() => {
        if(bulkBeneficiaryOtpCount === 1) {
            toast.error("Error: OTP does not match. 2 attempts left");
        } else if(bulkBeneficiaryOtpCount === 2) {
            toast.error("Error: OTP does not match. 1 attempt left");
        } else if(bulkBeneficiaryOtpCount === 3) {
            toast.error("Error: You have entered the wrong OTP thrice and will now be logged out.");
            setIsOtpModalOpen(false);
            dispatch(walletAction.resetBulkBeneficiaryOtpCount());
            setTimeout(() => {
                logoutUser();
            }, 3000);
        }
        // eslint-disable-next-line
    }, [bulkBeneficiaryOtpCount]);
    

    return (
        <div>

            <DynamicHeadTag
                headerText="Beneficiaries | Wallet"
            />

                <>

                    <BulkBeneficiariesOtpModal
                        target="OTP"
                        title="Enter OTP"
                        description={"Enter OTP sent to " + maskEmailAddress(userInfo?.member?.email)}
                        pin={(e) => setOtp(e)}
                        submit={() => {
                            let data = new FormData();
                            data.append('otp', otp);
                            data.append('csv', bulkUpload);
                            
                            dispatch(walletAction.createBulkBeneficiaries(userInfo.token, data));
                        }}
                        modalLoading={bulkBeneficiaryCreateLoading}
                        isOpenPin={isOtpModalOpen}
                        setIsOpenPin={setIsOtpModalOpen}
                        onResend={() => {
                            dispatch(walletAction.generateBulkBeneficiaryOtp(userInfo.token, "access-pin")).then(() => {
                                setResendShown(false);
                            })
                        }}
                        resendLoading={bulkBeneficiaryOtpLoading}
                        resendShown={resendShown}
                        setResendShown={setResendShown}
                    />

                    
                    <ModalAlertBulkBeneficiaries
                        successText={<div>
                                        Uploaded successfully
                                        <Maybe condition={bulkBeneficiaryCreateData?.data?.failedRecords?.length > 0}>
                                            <div className="w-full bg-[#EBF5F9] border border-[#E5E7EB] rounded-md my-4 p-3">
                                                <div className="flex items-center justify-between w-full px-5 rounded-md text-sm bg-[#F3F4F6]">
                                                    <p className="mb-0 text-[#DC2626]">{bulkBeneficiaryCreateData?.data?.failedRecords?.length} uploads failed</p>
                                                        <CSVLink filename="Failed_beneficiaries_upload" ref={csvRef} columns={columns} data={failedUploads}>
                                                            <div className="flex items-center text-ep-primary-600 cursor-pointer">
                                                                <img src={bulkAirtimeDownload} alt="download" className="mr-1" /> CSV data
                                                            </div>
                                                        </CSVLink>
                                                </div>
                                            </div>
                                        </Maybe>
                                    </div>
                        }
                        dismissText="Go back to Beneficiaries"
                        isOpenModalAlert={isSuccessModalOpen}
                        setIsOpenModalAlert={setIsSuccessModalOpen}
                        submit={() => {
                            setIsSuccessModalOpen(false);
                            history.push("/payments/beneficiaries");
                        }}
                    />


                    <div className="lg:flex">
                        <div className="w-full lg:w-1/2">
                            <div className="page-title flex">
                                    <BackButtonPage link="/payments/beneficiaries" />
                                <div>
                                    Add Bulk Beneficiaries
                                </div>
                            </div>
                        </div>
                        <div className="w-full lg:w-1/2 flex mt-2 lg:mt-0 lg:justify-end space-x-3"></div>
                    </div>


                    <div className="bg-white pb-16 mt-8 ml-12 rounded-md w-full lg:w-4/5">
                        <div className="font-medium p-8 lg:text-lg">
                            Upload CSV
                        </div>

                        <div className="w-4/5 lg:w-2/5 mx-auto">
                            <div className="h-64 border border-dashed border-ep-primary rounded-2xl overflow-hidden">

                                <Maybe condition={bulkUpload === null}>
                                    <FileUploader handleChange={(e) => setBulkUpload(e)} name="csvupload" multiple={false} types={["csv"]} onTypeError={(err) => toast.error(err)} onSizeError={(err) => toast.error(err)}>
                                        <FileUploadUI type="csv" />
                                    </FileUploader>
                                </Maybe>

                                <Maybe condition={bulkUpload !== null}>
                                    <div className="w-full h-full p-6 bg-[#FBFCFF] flex items-center justify-center">
                                        <div>
                                            <div className="h-20 flex">
                                                <img src={iconDocCsv} alt="file upload" className="object-contain mx-auto" />
                                            </div>
                                            <div className="mt-4 flex space-x-4 justify-between items-center">
                                                <div>
                                                    <div className="flex space-x-4">
                                                        <div className="max-w-sm ellipsis">{bulkUpload?.name}</div>
                                                        <div>•</div>
                                                        <div>{getFileSize(bulkUpload?.size)}</div>
                                                    </div>
                                                    <div className="w-full h-1 mt-1 bg-[#10B759] rounded-full"></div>
                                                </div>
                                                <div>
                                                    <FontAwesomeIcon icon="times-circle" className="cursor-pointer hover:text-red-500" onClick={() => setBulkUpload(null)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Maybe>

                            </div>

                            <Maybe condition={bulkUpload === null}>
                                <div>
                                    <a href="https://ep-mediafiles.s3.eu-west-1.amazonaws.com/Bulk_beneficiaries_template_csv_1690483831705.csv" target="_blank" rel="noreferrer" download className="w-max mt-4 flex items-center text-ep-primary text-sm hover:underline cursor-pointer ml-auto">
                                        <img src={iconDownload} alt="download template" className="mr-1" />
                                        Download sample file
                                    </a>
                                    <a href="https://ep-mediafiles.s3.eu-west-1.amazonaws.com/Bank_Codes_xlsx_1690799237144.xlsx" target="_blank" rel="noreferrer" download className="w-max mt-4 flex items-center text-ep-primary text-sm hover:underline cursor-pointer ml-auto">
                                        <img src={iconDownload} alt="download template" className="mr-1" />
                                        Download bank codes
                                    </a>
                                </div>
                            </Maybe>
                            
                            
                            <Maybe condition={bulkUpload !== null}>
                                <div className="flex items-center justify-start mt-10">
                                    
                                    <ButtonLoader onClick={onProceed} loading={bulkBeneficiaryOtpLoading} className="btn btn-ep-primary mr-5">
                                        {bulkBeneficiaryOtpLoading ? "Initializing..." : "Add beneficiaries"}
                                    </ButtonLoader>
                                    
                                    <ButtonLoader type="button" onClick={() => setBulkUpload(null)} className="btn btn-transparent-primary">
                                        Cancel
                                    </ButtonLoader>
                                </div>
                            </Maybe>
                        </div>
                    </div>
                </>
        </div>
    )
}


export const BulkBeneficiariesOtpModal = (props) => {
    const {isOpenPin, setIsOpenPin, onResend, resendLoading, resendShown, setResendShown} = props;
    const resetAccessPinRef = useRef();
    
    const pinLength = 4;
    const [pin, setPin] = useState("");
    let elementRef = useRef();

    const submitForm = async (e) => {
        e.preventDefault();
        if (pin !== "" && pin.length === pinLength){
            return (props.submit());
        }
        else{
            toast.error("Please enter a valid " + props.target);
        }
    }

    const clearInputPin =() => {
        if (elementRef.currentIndex !== undefined){
            elementRef.clear();
            setPin("");
        }
    }

    useEffect(() => {
        clearInputPin();
        setResendShown(false);
        // eslint-disable-next-line
    }, [isOpenPin]);

    return (
        <>
        
            <Maybe condition={props.showForgotPin === true}>
                <ResetAccessPin ref={resetAccessPinRef} />
            </Maybe>

            <FormDrawer display="center" size="xl" isOpen={isOpenPin} setIsOpen={setIsOpenPin}>

                <Maybe condition={props.modalLoading === true}>
                    <div className="p-12">
                        <PageContent loading={props.modalLoading} />
                    </div>
                </Maybe>

                <Maybe condition={!props.modalLoading || props.modalLoading === false}>
                    <form onSubmit={submitForm} className="p-12">
                        <div>
                            <div className="text-2xl font-bold">
                                {props.title}
                            </div>
                            <Maybe condition={props.description !== undefined}>
                                <div className="text-fade">
                                    {props.description}
                                </div>
                            </Maybe>
                        </div>

                        <div className="h-16 mt-14">
                            <PinInput 
                                length={pinLength} 
                                initialValue={pin}
                                onChange={(value, index) => {setPin(value); props.pin(value)}} 
                                type="numeric" 
                                inputMode="number"
                                inputStyle={{width: '70px', border: "none", borderBottom: "2px solid #ddd", marginRight: "25px", fontSize: "60px", fontWeight: "bold", paddingBottom: "20px"}}
                                inputFocusStyle={{borderBottom: "2px solid #000"}}
                                onComplete={(value, index) => {}}
                                autoSelect={true}
                                focus={true}
                                secret={true}
                                ref={(n) => (elementRef = n)}
                            />
                        </div>
                        
                        <Maybe condition={isOpenPin === true && resendShown === false}>
                            <div className="text-[#374151] mt-8">
                                Resend OTP in <Countdown minutes={1} onExpiry={() => setResendShown(true)} />
                            </div>
                            
                        </Maybe>

                        <Maybe condition={resendShown}>
                            <div className="mt-8 flex justify-start">
                                <div className="text-[#374151]">
                                    Didn't receive OTP? &nbsp;
                                </div>
                                <button onClick={onResend} disabled={resendLoading} type="button" className={`text-ep-primary font-medium cursor-pointer ${resendLoading && "cursor-not-allowed"}`}>
                                    {resendLoading ? "Resending..." : "Resend OTP"}
                                </button>
                            </div>
                        </Maybe>

                        <Maybe condition={props.showForgotPin === true}>
                            <div className="mt-2 flex justify-end">
                                <div onClick={() => {setIsOpenPin(false); resetAccessPinRef.current?.initiateResetPin()}} className="text-ep-primary font-semibold hover:underline cursor-pointer">
                                    Forgot Pin?
                                </div>
                            </div>
                        </Maybe>

                        <div className="mt-10 flex space-x-4">
                            <ButtonLoader loading={props.loading || resendLoading} type="submit" className="btn btn-ep-primary">
                                Continue
                            </ButtonLoader>
                            <button type="button" onClick={() => setIsOpenPin(false)} className="btn btn-transparent-primary">
                                Cancel
                            </button>
                        </div>
                    </form>
                </Maybe>

            </FormDrawer>
        </>
    )
}


const ModalAlertBulkBeneficiaries = (props) => {
    const {isOpenModalAlert, setIsOpenModalAlert, subText, closeDialog, loading} = props;
    const {button1, button2, button3} = props;
    const successImg = props.successImg || successGif;
    const successText = props.successText || "Successful";
    const dismissText = props.dismissText || "Dismiss";
    const dismiss = () => {
        if (props.submit !== undefined){
            props.submit();
        }
        else{
            setIsOpenModalAlert(false)
        }
    }
    return (
        <FormDrawer display="center" size="md" isOpen={isOpenModalAlert} setIsOpen={setIsOpenModalAlert} closeDialog={closeDialog}>
            <div className="p-12 max-w-md">
                <Maybe condition={loading === true}>
                    <Spinner />
                </Maybe>
                    <div className="w-60 h-60 mx-auto flex items-center justify-center">
                        <img src={successImg} alt="Success" className="object-contain" />
                    </div>
                    <div className="mt-0 text-xl text-center">
                        {successText}
                    </div>
                    <Maybe condition={subText !== undefined}>
                        <div className="mt-2 text-fade text-center">
                            {subText}
                        </div>
                    </Maybe>
                    <div className="mt-6">
                        <Maybe condition={button1 !== undefined}>
                            <ButtonLoader type="button" loading={button1?.loading || false} onClick={button1?.click} className={button1?.class + " mb-2"}>
                                {button1?.text}
                            </ButtonLoader>
                        </Maybe>
                        <Maybe condition={button2 !== undefined}>
                            <ButtonLoader type="button" loading={button2?.loading || false} onClick={button2?.click} className={button2?.class + " mb-2"}>
                                {button2?.text}
                            </ButtonLoader>
                        </Maybe>
                        <Maybe condition={button3 !== undefined}>
                            <ButtonLoader type="button" loading={button3?.loading || false} onClick={button3?.click} className={button3?.class + " mb-2"}>
                                {button3?.text}
                            </ButtonLoader>
                        </Maybe>
                        <Maybe condition={props.dismissText !== undefined && props.dismissText !== null}>
                            <button type="button" onClick={dismiss} className="btn btn-block btn-transparent-primary">
                                {dismissText}
                            </button>
                        </Maybe>
                    </div>
            </div>
        </FormDrawer>
    )
}


const Countdown = ({ hours = 0, minutes = 0, seconds = 0, onExpiry }) => {
    
    const [time, setTime] = useState({
        hours: parseInt(hours),
        minutes: parseInt(minutes),
        seconds: parseInt(seconds),
    });
    
    
    useEffect(() => {
        const countdownInterval = setInterval(() => {
            if (time.hours === 0 && time.minutes === 0 && time.seconds === 0) {
            clearInterval(countdownInterval);
            onExpiry();
            } else {
            if (time.seconds > 0) {
                setTime(prevTime => ({ ...prevTime, seconds: prevTime.seconds - 1 }));
            } else {
                if (time.minutes > 0) {
                setTime(prevTime => ({
                    ...prevTime,
                    minutes: prevTime.minutes - 1,
                    seconds: 59,
                }));
                } else {
                if (time.hours > 0) {
                    setTime(prevTime => ({
                    ...prevTime,
                    hours: prevTime.hours - 1,
                    minutes: 59,
                    seconds: 59,
                    }));
                }
                }
            }
            }
        }, 1000);
        
        
        return () => clearInterval(countdownInterval);
        // eslint-disable-next-line
    }, [time]);
    
    
    return (
        <span>{`${time.minutes.toString().padStart(2, '0')}:${time.seconds.toString().padStart(2, '0')}`}</span>
    );
};



export default BulkBeneficiaries;
